import React from 'react'
import { translate } from 'react-i18next'

import './AuthFooter.css'
import { QbOutsideLink } from '../QbLink/QbLink'
import { TERMS_AND_CONDITIONS_URL, PRIVACY_POLICY_URL } from '../../../constants/constants'

const AuthFooter = ({ t }) => (
  <div className="auth-footer-container">
    <QbOutsideLink regular big to="https://qiibee.com" name={t('auth.footer-learn')} />
    <QbOutsideLink regular big to={PRIVACY_POLICY_URL} name={t('auth.footer-privacy')} />
    <QbOutsideLink regular big to={TERMS_AND_CONDITIONS_URL} name={t('auth.footer-terms')} />
  </div>
)

export default translate()(AuthFooter)



// WEBPACK FOOTER //
// ./src/components/shared/AuthFooter/AuthFooter.js